export const routes = [
  {
    route: "inicio",
    naming: "Inicio",
  },
  {
    route: "requisitos",
    naming: "Requisitos",
  },
  {
    route: "nosotros",
    naming: "Nosotros",
  },
  {
    route: "beneficios",
    naming: "Beneficios",
  },
  {
    route: "faq",
    naming: "FAQ",
  },
];
